import _implicitStylesheets from "./listingCard.css";
import _implicitScopedStylesheets from "./listingCard.scoped.css?scoped=true";
import _axImage from "ax/image";
import _axCard from "ax/card";
import _axBadge from "ax/badge";
import _axIcon from "ax/icon";
import _wdsStarRatings from "wds/starRatings";
import _wdsTag from "wds/tag";
import _wdsPopover from "wds/popover";
import _wdsTitledGroup from "wds/titledGroup";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"}${"a0:target"}${"a0:rel"} class="preview-card-target${0}" tabindex="-1" aria-hidden="true"${2}></a>`;
const $fragment2 = parseFragment`<a${"a0:href"}${"a0:target"}${"a0:rel"}${"a0:aria-label"} type-style="display-7" class="preview-title${0}"${2}>${"t1"}</a>`;
const $fragment3 = parseFragment`<span type-style="display-7" class="preview-title${0}" data-testid="static-card-title"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<p type-style="body-3" class="preview-publisher${0}"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<p type-style="body-3" class="preview-description${0}"${2}>${"t1"}</p>`;
const $fragment6 = parseFragment`<a${"a0:href"}${"a0:target"}${"a0:rel"}${"a0:aria-label"} type-style="display-7" util-style="ellipsis" class="with-badge-title${0}"${2}>${"t1"}</a>`;
const $fragment7 = parseFragment`<span type-style="display-7" util-style="ellipsis" class="with-badge-title${0}" data-testid="static-card-title"${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<p type-style="body-3" util-style="ellipsis" class="with-badge-publisher${0}"${2}>${"t1"}</p>`;
const $fragment9 = parseFragment`<p type-style="body-3" class="with-badge-description${0}" util-style="multi-line-ellipsis"${2}>${"t1"}</p>`;
const $fragment10 = parseFragment`<button${"a0:id"} class="category-overflow-button${0}" type="button"${"a0:aria-label"}${"a0:aria-describedby"}${"a0:aria-expanded"} aria-haspopup="dialog"${2}>${"t1"}</button>`;
const $fragment11 = parseFragment`<h3 class="category-popover-content-title${0}" type-style="body-3" util-style="ellipsis" role="heading" aria-level="3"${2}>${"t1"}</h3>`;
const $fragment12 = parseFragment`<a${"a0:href"} class="category-link${0}"${2}>${"t1"}</a>`;
const $fragment13 = parseFragment`<span class="category-label${0}"${2}>${"t1"}</span>`;
const $fragment14 = parseFragment`<div class="divider${0}"${2}></div>`;
const $fragment15 = parseFragment`<button${"a0:id"} class="overflow-button${0}" type="button"${"a0:aria-label"}${"a0:aria-describedby"}${"a0:aria-expanded"} aria-haspopup="dialog"${2}>${"t1"}</button>`;
const $fragment16 = parseFragment`<h3 class="badge-popover-content-title${0}" type-style="body-3" util-style="ellipsis"${"a0:id"} role="heading" aria-level="3"${2}>${"t1"}</h3>`;
const $fragment17 = parseFragment`<a${"a0:href"}${"a0:target"}${"a0:rel"}${"a0:aria-label"} type-style="display-7" util-style="ellipsis" class="card-target${0}"${2}>${"t1"}</a>`;
const $fragment18 = parseFragment`<span type-style="display-7" util-style="ellipsis" class="card-target${0}" data-testid="static-card-title"${2}>${"t1"}</span>`;
const $fragment19 = parseFragment`<p type-style="body-3" util-style="ellipsis"${3}>${"t1"}</p>`;
const $fragment20 = parseFragment`<p type-style="body-3" class="description${0}" util-style="multi-line-ellipsis"${2}>${"t1"}</p>`;
const $fragment21 = parseFragment`<button${"a0:id"} class="category-overflow-button${0}" type="button"${"a0:aria-label"}${"a0:aria-describedby"}${"a0:aria-expanded"} aria-haspopup="dialog"${2}>${"t1"}</button>`;
const $fragment22 = parseFragment`<span class="category-overflow-button${0}" data-measure-overflow${2}>${"t1"}</span>`;
const $fragment23 = parseFragment`<h3 class="category-popover-content-title${0}" type-style="body-3" util-style="ellipsis" role="heading" aria-level="3"${2}>${"t1"}</h3>`;
const $fragment24 = parseFragment`<a${"a0:href"} class="category-link${0}"${2}>${"t1"}</a>`;
const $fragment25 = parseFragment`<span class="category-label${0}"${2}>${"t1"}</span>`;
const $fragment26 = parseFragment`<div class="divider${0}"${2}></div>`;
const $fragment27 = parseFragment`<button${"a0:id"} class="overflow-button${0}" type="button"${"a0:aria-label"}${"a0:aria-describedby"}${"a0:aria-expanded"} aria-haspopup="dialog"${2}>${"t1"}</button>`;
const $fragment28 = parseFragment`<h3 class="badge-popover-content-title${0}" type-style="body-3" util-style="ellipsis"${"a0:id"} role="heading" aria-level="3"${2}>${"t1"}</h3>`;
const stc0 = {
  "type": "listingTile"
};
const stc1 = {
  classMap: {
    "preview-card": true
  },
  ref: "cardElement",
  props: {
    "role": "group",
    "padding": "medium",
    "shadow": "elevation-2"
  },
  key: 1
};
const stc2 = {
  "preview-logo": true
};
const stc3 = {
  classMap: {
    "with-badge-card": true
  },
  ref: "cardElement",
  props: {
    "role": "group",
    "padding": "medium",
    "shadow": "elevation-2"
  },
  key: 13
};
const stc4 = {
  classMap: {
    "with-badge-card-header": true
  },
  key: 14
};
const stc5 = {
  "with-badge-logo": true
};
const stc6 = {
  classMap: {
    "with-badge-header-end": true
  },
  key: 16
};
const stc7 = {
  "with-badge-platform-icon": true
};
const stc8 = {
  "with-badge-platform-icon": true,
  "consultants-icon": true
};
const stc9 = {
  attrs: {
    "grid": "",
    "flow": "wrap",
    "align-items": "spread",
    "row-gap": "xx-small"
  },
  key: 27
};
const stc10 = {
  classMap: {
    "tags": true
  },
  key: 32
};
const stc11 = {
  classMap: {
    "tags-container": true
  },
  key: 33
};
const stc12 = {
  "agentforce-icon": true
};
const stc13 = {
  "category-popover-content": true
};
const stc14 = {
  classMap: {
    "category-list": true
  },
  attrs: {
    "role": "list"
  },
  key: 43
};
const stc15 = {
  "role": "listitem"
};
const stc16 = {
  classMap: {
    "badges": true
  },
  key: 49
};
const stc17 = {
  classMap: {
    "badges-container": true
  },
  key: 52
};
const stc18 = {
  "badge-popover-content": true
};
const stc19 = {
  classMap: {
    "standard-header-badge": true
  },
  key: 63
};
const stc20 = {
  attrs: {
    "grid": ""
  },
  key: 65
};
const stc21 = {
  classMap: {
    "title-creds": true
  },
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 67
};
const stc22 = {
  attrs: {
    "grid": "",
    "flow": "wrap",
    "align-items": "spread",
    "row-gap": "xx-small"
  },
  key: 74
};
const stc23 = {
  classMap: {
    "tags": true
  },
  key: 79
};
const stc24 = {
  classMap: {
    "tags-measure": true
  },
  attrs: {
    "aria-hidden": "true"
  },
  ref: "tagsMeasure",
  key: 86
};
const stc25 = {
  "data-measure-tag": ""
};
const stc26 = {
  classMap: {
    "category-list": true
  },
  attrs: {
    "role": "list"
  },
  key: 94
};
const stc27 = {
  classMap: {
    "badges": true
  },
  key: 100
};
const stc28 = {
  classMap: {
    "badges-container": true
  },
  key: 103
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, fid: api_scoped_frag_id, sp: api_static_part, st: api_static_fragment, c: api_custom_element, d: api_dynamic_text, h: api_element, k: api_key, i: api_iterator, gid: api_scoped_id, f: api_flatten, ncls: api_normalize_class_name} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19, _m20, _m21, _m22, _m23, _m24} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [$cmp.isPreview ? api_custom_element("ax-card", _axCard, stc1, [!$cmp.disableNavigation ? api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "href": api_scoped_frag_id($cmp.cardUrl),
      "target": $cmp.cardTarget,
      "rel": $cmp.cardRel
    }
  }, null)]) : null, api_custom_element("ax-image", _axImage, {
    classMap: stc2,
    props: {
      "height": "56px",
      "width": "56px",
      "imgSrc": $cmp.listingCardData.image,
      "alt": $cmp.altTextMessage
    },
    key: 4
  }), !$cmp.disableNavigation ? api_static_fragment($fragment2, 6, [api_static_part(0, {
    attrs: {
      "href": api_scoped_frag_id($cmp.cardUrl),
      "target": $cmp.cardTarget,
      "rel": $cmp.cardRel,
      "aria-label": $cmp.cardAriaLabel
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, $cmp.disableNavigation ? api_static_fragment($fragment3, 8, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, api_static_fragment($fragment4, 10, [api_static_part(1, null, "by " + api_dynamic_text($cmp.listingCardData.publisher))]), api_static_fragment($fragment5, 12, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.description))])]) : null, $cmp.isWithBadge ? api_custom_element("ax-card", _axCard, stc3, [api_element("div", stc4, [api_custom_element("ax-image", _axImage, {
    classMap: stc5,
    props: {
      "height": "64px",
      "width": "64px",
      "imgSrc": $cmp.listingCardData.image,
      "alt": $cmp.altTextMessage
    },
    key: 15
  }), api_element("div", stc6, [$cmp.resolvedHeaderBadgeLabel ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.resolvedHeaderBadgeLabel,
      "icon": $cmp.resolvedHeaderBadgeIcon,
      "iconDescription": $cmp.resolvedHeaderBadgeLabel,
      "theme": $cmp.resolvedHeaderBadgeTheme
    },
    key: 17
  }) : null, $cmp.showSalesforceIcon ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc7,
    props: {
      "icon": "salesforce1",
      "size": "small",
      "iconDescription": $cmp.salesforceIconDescription
    },
    key: 18
  }) : null, $cmp.showSlackIcon ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc7,
    props: {
      "iconSetType": "product",
      "icon": "slack",
      "size": "small",
      "iconDescription": $cmp.slackIconDescription
    },
    key: 19
  }) : null, $cmp.showConsultantsIcon ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc8,
    props: {
      "iconSetType": "standard",
      "icon": "team_member",
      "size": "large",
      "iconDescription": $cmp.consultantsIconDescription
    },
    key: 20
  }) : null])]), !$cmp.disableNavigation ? api_static_fragment($fragment6, 22, [api_static_part(0, {
    attrs: {
      "href": api_scoped_frag_id($cmp.cardUrl),
      "target": $cmp.cardTarget,
      "rel": $cmp.cardRel,
      "aria-label": $cmp.cardAriaLabel
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, $cmp.disableNavigation ? api_static_fragment($fragment7, 24, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, api_static_fragment($fragment8, 26, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.publisher))]), $cmp.showRatings ? api_element("div", stc9, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "size": "xsmall",
      "spaceBetween": "xsmall",
      "value": $cmp.listingCardData.averageRating,
      "reviewCount": $cmp.listingCardData.reviewsAmount,
      "readOnly": true,
      "labelPosition": "right",
      "ariaLabel": $cmp.screenReaderMessageForRating
    },
    key: 28
  }), $cmp.showChat ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.chatLabel,
      "variant": "outline",
      "icon": "chat",
      "iconDescription": "Speech bubble"
    },
    key: 29
  }) : null]) : null, api_static_fragment($fragment9, 31, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.description))]), $cmp.showTags ? api_element("section", stc10, [api_element("div", stc11, api_flatten([$cmp.agentforceBadges.length ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc12,
    props: {
      "icon": "agentforce",
      "iconSetType": "product",
      "size": "medium",
      "iconDescription": $cmp.agentIconAltText
    },
    key: 34
  }) : null, api_iterator($cmp.visibleTags, function (item) {
    return [item.isNavigable ? api_custom_element("wds-tag", _wdsTag, {
      props: {
        "href": item.filter,
        "ariaLabel": item.ariaLabel,
        "text": item.name
      },
      key: api_key(35, item.id)
    }) : null, !item.isNavigable ? api_custom_element("wds-tag", _wdsTag, {
      props: {
        "ariaLabel": item.ariaLabel,
        "text": item.name
      },
      key: api_key(36, item.id)
    }) : null];
  }), $cmp.showCategoryOverflow ? api_static_fragment($fragment10, 38, [api_static_part(0, {
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleCategoryClick)),
      "keydown": _m4 || ($ctx._m4 = api_bind($cmp.handleCategoryKeyboardEvent))
    },
    attrs: {
      "id": api_scoped_id($cmp.categoryOverflowButtonId),
      "aria-label": $cmp.categoryOverflowAccessibleLabel,
      "aria-describedby": api_scoped_id($cmp.categoryPopoverContentId),
      "aria-expanded": $cmp.showCategoryPopover
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.categoryOverflowLabel))]) : null]))]) : null, api_custom_element("wds-popover", _wdsPopover, {
    ref: "categoryOverflowButton",
    props: {
      "show": $cmp.showCategoryPopover,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 39,
    on: {
      "close": _m5 || ($ctx._m5 = api_bind($cmp.handleCategoryPopoverClose))
    }
  }, [api_element("div", {
    classMap: stc13,
    attrs: {
      "id": api_scoped_id($cmp.categoryPopoverContentId),
      "role": "dialog",
      "aria-label": $cmp.categoryPopoverAriaLabel,
      "aria-modal": "false",
      "tabindex": "-1"
    },
    key: 40
  }, [api_static_fragment($fragment11, 42, [api_static_part(1, null, api_dynamic_text($cmp.allCategoriesLabel))]), api_element("div", stc14, api_iterator($cmp.tags, function (item) {
    return api_element("div", {
      attrs: stc15,
      key: api_key(44, item.id)
    }, [item.isNavigable ? api_static_fragment($fragment12, 46, [api_static_part(0, {
      on: {
        "click": _m7 || ($ctx._m7 = api_bind($cmp.handleCategoryPopoverClose))
      },
      attrs: {
        "href": api_scoped_frag_id(item.filter)
      }
    }, null), api_static_part(1, null, api_dynamic_text(item.name))]) : null, !item.isNavigable ? api_static_fragment($fragment13, 48, [api_static_part(1, null, api_dynamic_text(item.name))]) : null]);
  }))])]), $cmp.agentforceBadges.length ? api_element("div", stc16, [api_static_fragment($fragment14, 51), api_element("div", stc17, api_flatten([api_iterator($cmp.visibleBadges, function (badge) {
    return api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: api_key(53, badge.iteratorKey)
    });
  }), $cmp.showOverflowCount ? api_static_fragment($fragment15, 55, [api_static_part(0, {
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleBadgeClick)),
      "keydown": _m11 || ($ctx._m11 = api_bind($cmp.handleTooltipKeyboardEvent))
    },
    attrs: {
      "id": api_scoped_id($cmp.overflowButtonId),
      "aria-label": $cmp.overflowAccessibleLabel,
      "aria-describedby": api_scoped_id($cmp.popoverContentId),
      "aria-expanded": $cmp.showBadgePopover
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.overflowLabel))]) : null]))]) : null, api_custom_element("wds-popover", _wdsPopover, {
    ref: "overflowButton",
    props: {
      "show": $cmp.showBadgePopover,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 56,
    on: {
      "close": _m12 || ($ctx._m12 = api_bind($cmp.handlePopoverClose))
    }
  }, [api_element("div", {
    classMap: stc18,
    attrs: {
      "id": api_scoped_id($cmp.popoverContentId),
      "role": "dialog",
      "aria-label": $cmp.popoverAriaLabel,
      "aria-modal": "false",
      "tabindex": "-1"
    },
    key: 57
  }, [api_static_fragment($fragment16, 59, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id($cmp.popoverContentTitleId)
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.agentforceContentTitle))]), api_element("div", {
    attrs: {
      "role": "group",
      "aria-labelledby": api_scoped_id($cmp.popoverContentTitleId)
    },
    key: 60
  }, [$cmp.agentforceBadges.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "badges": $cmp.agentforceBadges
    },
    key: 61
  }) : null])])])]) : null, $cmp.isStandardCard ? api_custom_element("ax-card", _axCard, {
    className: api_normalize_class_name($cmp.standardCardCssClass),
    ref: "cardElement",
    props: {
      "role": "group",
      "padding": "medium",
      "shadow": $cmp.cardFrameType
    },
    key: 62
  }, [$cmp.resolvedHeaderBadgeLabel ? api_element("div", stc19, [api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.resolvedHeaderBadgeLabel,
      "icon": $cmp.resolvedHeaderBadgeIcon,
      "iconDescription": $cmp.resolvedHeaderBadgeLabel,
      "theme": $cmp.resolvedHeaderBadgeTheme
    },
    key: 64
  })]) : null, api_element("section", stc20, [api_custom_element("ax-image", _axImage, {
    props: {
      "height": "64px",
      "width": "64px",
      "imgSrc": $cmp.listingCardData.image,
      "alt": $cmp.altTextMessage
    },
    key: 66
  }), api_element("div", stc21, [!$cmp.disableNavigation ? api_static_fragment($fragment17, 69, [api_static_part(0, {
    attrs: {
      "href": api_scoped_frag_id($cmp.cardUrl),
      "target": $cmp.cardTarget,
      "rel": $cmp.cardRel,
      "aria-label": $cmp.cardAriaLabel
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, $cmp.disableNavigation ? api_static_fragment($fragment18, 71, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.title))]) : null, api_static_fragment($fragment19, 73, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.publisher))]), $cmp.showRatings ? api_element("div", stc22, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "size": "xsmall",
      "spaceBetween": "xsmall",
      "value": $cmp.listingCardData.averageRating,
      "reviewCount": $cmp.listingCardData.reviewsAmount,
      "readOnly": true,
      "labelPosition": "right",
      "ariaLabel": $cmp.screenReaderMessageForRating
    },
    key: 75
  }), $cmp.showChat ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.chatLabel,
      "variant": "outline",
      "icon": "chat",
      "iconDescription": "Speech bubble"
    },
    key: 76
  }) : null]) : null])]), api_static_fragment($fragment20, 78, [api_static_part(1, null, api_dynamic_text($cmp.listingCardData.description))]), $cmp.showTags ? api_element("section", stc23, [api_element("div", {
    className: api_normalize_class_name($cmp.tagsContainerClass),
    ref: "tagsContainer",
    key: 80
  }, api_flatten([$cmp.agentforceBadges.length ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc12,
    props: {
      "icon": "agentforce",
      "iconSetType": "product",
      "size": "medium",
      "iconDescription": $cmp.agentIconAltText
    },
    key: 81
  }) : null, api_iterator($cmp.visibleTags, function (item) {
    return [item.isNavigable ? api_custom_element("wds-tag", _wdsTag, {
      props: {
        "href": item.filter,
        "ariaLabel": item.ariaLabel,
        "text": item.name
      },
      key: api_key(82, item.id)
    }) : null, !item.isNavigable ? api_custom_element("wds-tag", _wdsTag, {
      props: {
        "ariaLabel": item.ariaLabel,
        "text": item.name
      },
      key: api_key(83, item.id)
    }) : null];
  }), $cmp.showCategoryOverflow ? api_static_fragment($fragment21, 85, [api_static_part(0, {
    on: {
      "click": _m15 || ($ctx._m15 = api_bind($cmp.handleCategoryClick)),
      "keydown": _m16 || ($ctx._m16 = api_bind($cmp.handleCategoryKeyboardEvent))
    },
    attrs: {
      "id": api_scoped_id($cmp.categoryOverflowButtonId),
      "aria-label": $cmp.categoryOverflowAriaLabel,
      "aria-describedby": api_scoped_id($cmp.categoryPopoverContentId),
      "aria-expanded": $cmp.showCategoryPopover
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.categoryOverflowLabel))]) : null])), $cmp.showTagsMeasureRow ? api_element("div", stc24, api_flatten([api_iterator($cmp.tags, function (item) {
    return api_custom_element("wds-tag", _wdsTag, {
      attrs: stc25,
      props: {
        "text": item.name
      },
      key: api_key(87, item.id)
    });
  }), api_static_fragment($fragment22, 89, [api_static_part(1, null, " " + api_dynamic_text($cmp.categoryOverflowLabelMax) + " ")])])) : null]) : null, api_custom_element("wds-popover", _wdsPopover, {
    ref: "categoryOverflowButton",
    props: {
      "show": $cmp.showCategoryPopover,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 90,
    on: {
      "close": _m17 || ($ctx._m17 = api_bind($cmp.handleCategoryPopoverClose))
    }
  }, [api_element("div", {
    classMap: stc13,
    attrs: {
      "id": api_scoped_id($cmp.categoryPopoverContentId),
      "role": "dialog",
      "aria-label": $cmp.categoryPopoverAriaLabel,
      "aria-modal": "false",
      "tabindex": "-1"
    },
    key: 91
  }, [api_static_fragment($fragment23, 93, [api_static_part(1, null, api_dynamic_text($cmp.allCategoriesLabel))]), api_element("div", stc26, api_iterator($cmp.tags, function (item) {
    return api_element("div", {
      attrs: stc15,
      key: api_key(95, item.id)
    }, [item.isNavigable ? api_static_fragment($fragment24, 97, [api_static_part(0, {
      on: {
        "click": _m19 || ($ctx._m19 = api_bind($cmp.handleCategoryPopoverClose))
      },
      attrs: {
        "href": api_scoped_frag_id(item.filter)
      }
    }, null), api_static_part(1, null, api_dynamic_text(item.name))]) : null, !item.isNavigable ? api_static_fragment($fragment25, 99, [api_static_part(1, null, api_dynamic_text(item.name))]) : null]);
  }))])]), $cmp.agentforceBadges.length ? api_element("div", stc27, [api_static_fragment($fragment26, 102), api_element("div", stc28, api_flatten([api_iterator($cmp.visibleBadges, function (badge) {
    return api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: api_key(104, badge.iteratorKey)
    });
  }), $cmp.showOverflowCount ? api_static_fragment($fragment27, 106, [api_static_part(0, {
    on: {
      "click": _m22 || ($ctx._m22 = api_bind($cmp.handleBadgeClick)),
      "keydown": _m23 || ($ctx._m23 = api_bind($cmp.handleTooltipKeyboardEvent))
    },
    attrs: {
      "id": api_scoped_id($cmp.overflowButtonId),
      "aria-label": $cmp.overflowAriaLabel,
      "aria-describedby": api_scoped_id($cmp.popoverContentId),
      "aria-expanded": $cmp.showBadgePopover
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.overflowLabel))]) : null]))]) : null, api_custom_element("wds-popover", _wdsPopover, {
    ref: "overflowButton",
    props: {
      "show": $cmp.showBadgePopover,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 107,
    on: {
      "close": _m24 || ($ctx._m24 = api_bind($cmp.handlePopoverClose))
    }
  }, [api_element("div", {
    classMap: stc18,
    attrs: {
      "id": api_scoped_id($cmp.popoverContentId),
      "role": "dialog",
      "aria-label": $cmp.popoverAriaLabel,
      "aria-modal": "false",
      "tabindex": "-1"
    },
    key: 108
  }, [api_static_fragment($fragment28, 110, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id($cmp.popoverContentTitleId)
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.agentforceContentTitle))]), api_element("div", {
    attrs: {
      "role": "group",
      "aria-labelledby": api_scoped_id($cmp.popoverContentTitleId)
    },
    key: 111
  }, [$cmp.agentforceBadges.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "badges": $cmp.agentforceBadges
    },
    key: 112
  }) : null])])])]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.hasRefs = true;
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-54c8un93slg";
tmpl.legacyStylesheetToken = "undefined-_listingCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
